import React,{ReactNode} from "react";

import {Container} from "./styles";

interface Props{
    children: ReactNode;
}

export function Panel({children}:Props){

    return(
        <Container>
            {children}
        </Container>
    )
};